var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgIconArrowDown = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 20 20"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "m14.952 8.712-4.248 4.247a1 1 0 0 1-1.416 0L5.041 8.712a1.001 1.001 0 1 1 1.416-1.416l3.54 3.539 3.539-3.54a1.001 1.001 0 0 1 1.416 1.417"
})));
export default SvgIconArrowDown;